export enum ProgressLabelState {
  current,
  future,
  complete,
  disabled,
}
